// @ts-check
import React from 'react';
import { connect } from 'react-redux';
import {
  PlainSelectField,
  ConnectedLabelAndError,
  RadioGroupField,
  DateMaskField,
  DateMaskInput,
} from 'shared/containers/portal_layout/HForm';
import { Field } from 'utils/reduxFormWrapper';

const intervalToUnitMap = {
  daily: 'days',
  weekly: 'weeks',
  monthly: 'months',
  yearly: 'years',
};

const everyN = [
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  26,
  27,
  28,
  29,
  30,
];

const RepeatSectionFields = ({ repeatUnit: repeatUnitValue }) => (
  <div className="repeat-fields" style={{ border: '1px solid blue' }}>
    <PlainSelectField
      name="repeatUnit"
      label="Repeats:"
      options={[
        { value: 'daily', label: 'daily' },
        { value: 'weekly', label: 'weekly' },
        { value: 'monthly', label: 'monthly' },
        { value: 'yearly', label: 'yearly' },
      ]}
    />
    <ConnectedLabelAndError fieldName="repeatEveryN" label="Repeat every:">
      <Field name="repeatEveryN" component="select" className="input-small">
        {everyN.map(n => (
          <option key={n} value={n}>
            {n}
          </option>
        ))}
      </Field>{' '}
      <span>{intervalToUnitMap[repeatUnitValue]}</span>
    </ConnectedLabelAndError>

    {repeatUnitValue === 'monthly' && (
      <RadioGroupField
        name="repeatMonthlyBy"
        label="Repeat by:"
        options={[
          { value: 'dayOfMonth', label: 'day of the month' },
          { value: 'dayOfWeek', label: 'day of the week' },
        ]}
      />
    )}

    <DateMaskField name="repeatStartsOn" label="Starts on:" className="input-small" />

    <ConnectedLabelAndError fieldName="repeatEndType" label="Ends:">
      <label>
        <Field name="repeatEndType" component="input" type="radio" value="never" /> Never
      </label>
      <label>
        <Field name="repeatEndType" component="input" type="radio" value="occurences" /> After{' '}
        <span>
          <Field name="repeatEndOccurences" component="input" type="number" style={{ width: 40 }} />{' '}
          occurences
        </span>
      </label>
      <label>
        <Field name="repeatEndType" component="input" type="radio" value="date" /> On{' '}
        <span>
          <DateMaskInput name="repeatEndDate" className="input-small" />
        </span>
      </label>
    </ConnectedLabelAndError>
  </div>
);

RepeatSectionFields.displayName = 'RepeatSectionFields';

// const newBlockFormSelector = formValueSelector('newBlock');
const repeatSectionMapStateToProps = (state, ownProps) => ({
  repeatUnit: ownProps.formValueSelector(state, 'repeatUnit'),
});

export default connect(repeatSectionMapStateToProps)(RepeatSectionFields);
